import { AuditPlan } from "@/lib/audit-plan";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ClipboardList, TrendingUp, AlertCircle, Rocket } from "lucide-react";
import { Progress } from "@/components/ui/progress";

type Props = { auditPlan: AuditPlan };

// TODO: These should be real calculations
const totalAssignments = 0;
const completedAssignments = 0;
const inProgressAssignments = 0;
const overdueAssignments = 0;

export const AuditPlanOverview = ({ auditPlan }: Props) => (
  <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Overall Progress</CardTitle>
        <TrendingUp className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{auditPlan.completionPercentage}%</div>
        <Progress value={auditPlan.completionPercentage} className="mt-2" />
      </CardContent>
    </Card>

    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Total Assignments</CardTitle>
        <ClipboardList className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{totalAssignments}</div>
        <p className="text-xs text-muted-foreground mt-1">
          {completedAssignments} completed
        </p>
      </CardContent>
    </Card>

    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">In Progress</CardTitle>
        <Rocket className="h-4 w-4 text-blue-600" />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{inProgressAssignments}</div>
        <p className="text-xs text-muted-foreground mt-1">Active assignments</p>
      </CardContent>
    </Card>

    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Overdue</CardTitle>
        <AlertCircle className="h-4 w-4 text-red-600" />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{overdueAssignments}</div>
        <p className="text-xs text-muted-foreground mt-1">Need attention</p>
      </CardContent>
    </Card>
  </div>
);
